import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'
import { t } from '@owl-nest/localize'
import { MapPicker, MapPickerProps } from './MapPicker'
import { ListPicker, ListPickerProps } from './ListPicker'

export { type Location } from './type'

export type LocationPickerProps = MapPickerProps & ListPickerProps

function LocationPickerComponent({ className, ...props }: LocationPickerProps) {
  const [type, setType] = React.useState<'list' | 'map'>('map')
  const [error, setError] = React.useState<any>(undefined)

  const selectedLocation = props.locations.find((location) => location.id === props.selected)

  React.useEffect(() => {
    if (selectedLocation === undefined && props.locations.length > 0) {
      const defaultLocation = props.locations[0]
      props.onSelect?.(defaultLocation)
    }
  }, [selectedLocation, props.locations])

  return (
    <div className={className}>
      {!error && (
        <plume.TabMenu>
          <plume.Tab active={type === 'map'}>
            <TabButton type="button" onClick={() => setType('map')}>
              {t('Map')}
            </TabButton>
          </plume.Tab>
          <plume.Tab active={type === 'list'}>
            <TabButton type="button" onClick={() => setType('list')}>
              {t('List')}
            </TabButton>
          </plume.Tab>
        </plume.TabMenu>
      )}
      {type === 'map' && (
        <MapPicker
          {...props}
          onError={(error) => {
            setError(error)
            setType('list')
          }}
        />
      )}
      {type === 'list' && <ListPicker {...props} />}
    </div>
  )
}

const TabButton = styled(plume.styles.button.UnstyledButton)`
  font-size: 13px; /* HACK: Irregular font manipulation */
  padding-bottom: 10px;
  font-weight: 600; /* HACK: Irregular font manipulation. */
`

export const LocationPicker = styled(LocationPickerComponent)`
  ${plume.Tab} {
    padding: 0;
    margin: 0 8px;
  }

  ${plume.TabMenu} {
    margin-bottom: 16px;
    justify-content: start;
  }
`
